import Custodian from './Custodian';
import CustodianRec from './CustodianRec';
import LoadUserData from '../../LoadUserData';

export const CustodianConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/custodian',
            component: LoadUserData(Custodian)
        },
        {
            path     : '/custodian_certificate_reconciliation',
            component: LoadUserData(CustodianRec)
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/custodian/CustodianConfig.js